import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow, Chip } from "@/components/Reveal";

const CONTACT_EMAIL = "allinhand@zohomail.com";

const TOPICS = [
  "Digital marketing strategy",
  "Business technology",
  "Lead generation",
  "Branding",
  "Digital products",
  "Marketing automation",
  "AI implementation",
  "Website strategy",
  "CRM planning",
  "Software opportunities",
  "Monetization strategy",
];

export const Consulting = () => (
  <section id="consulting" className="relative py-24 sm:py-32 bg-obsidian-900/50 border-y border-slate-800/60">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Eyebrow>One-on-One</Eyebrow>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white mt-4">
          Business Strategy &amp; Consulting
        </h2>
        <p className="text-slate-400 mt-4 max-w-2xl">
          Need direction before committing to a larger project? Schedule an individual consultation
          with All In Hand Marketing.
        </p>
      </Reveal>

      <Reveal delay={0.1} className="mt-10">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-slate-500 mb-5">
          Potential consultation topics
        </p>
        <div className="flex flex-wrap gap-2.5">
          {TOPICS.map((t) => (
            <Chip key={t}>{t}</Chip>
          ))}
        </div>
      </Reveal>

      <Reveal delay={0.15} className="mt-12">
        <div className="rounded-2xl border border-emerald-500/30 bg-emerald-500/5 p-6 mb-6" data-testid="consulting-booking-info">
          <p className="text-sm text-slate-200 leading-relaxed">
            <span className="text-emerald-400 font-semibold">How booking works:</span> a short form
            (name and email only), then pick a day and time. No payment is required to book — if
            your consultation leads to a proposed engagement, you approve its scope and price before
            anything is charged. Questions first?{" "}
            <a href={`mailto:${CONTACT_EMAIL}`} data-testid="consulting-email-link" className="text-gold underline underline-offset-2">
              {CONTACT_EMAIL}
            </a>
          </p>
        </div>
        <Link
          to="/intake?type=consultation"
          data-testid="consulting-cta-book"
          className="group inline-flex items-center gap-3 rounded-full bg-gold text-obsidian font-display font-bold px-8 py-4 hover:bg-gold-bright hover:-translate-y-0.5 transition-all duration-300 gold-ring"
        >
          Book a Consultation
          <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </Reveal>
    </div>
  </section>
);

export default Consulting;
